import React from 'react'
import fileImg from 'images/tmp_file_image.png'
import styles from './index.module.css'

const QuestionDetail = () => {



	return (
		<div className="page padding">
			<div className={styles.question}>
				<div className="flex-justify_between align_center">
					<strong>[1:1 문의]</strong>
					<i className="tag tag-round tag-blue-line">답변완료</i>
				</div>
				<div className={`${styles["question-title"]} mt_10`}>
					<span>#가입/로그인</span>
					<p className="ellipsis">휴대폰번호를 변경해야 합니다.<br />어느페이지에서 해야 하는건가요?</p>
					<span>2021.08.12 15:22:11</span>
				</div>
				<div className={`${styles["attach-list"]} mt_20`}>
					<div className="img-box">
						<img src={fileImg} alt="" />
					</div>
					<div className="img-box">
						<img src={fileImg} alt="" />
					</div>
				</div>

				<div className={`${styles["answer-area"]} mt_40`}>
					<strong>고객님의 문의에 대한 답변입니다.<br />
						추가적인 문의가 있으시면 다시 문의해주세요.
					</strong>
					<p className="mt_20">
						안녕하세요. 모니 관리자 입니다.<br />
						문의주신 사항은 더보기 메뉴의 회원정보수정에서<br />
						기타 문의가 있으시면 설정메뉴의 문의하기에서 문의내용을 재등록해주세요.
					</p>
					<span className="mt_10">2021.08.12 15:22:11</span>
					<div className={`${styles["attach-list"]} mt_20`}>
						<div className="img-box">
							<img src={fileImg} alt="" />
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default QuestionDetail
